import React from "react";
import { Helmet } from "react-helmet-async";

const QuizMetaData = ({ quizType, senderName, quizConfig }) => {
  // Define metadata for each quiz type
  const getQuizMetadata = (type) => {
    // Static metadata map for existing quizzes
    const metadataMap = {
      "personality-check": {
        title: "Is our Personality compatible?",
        description: "personality quiz. See how compatible you are!",
        keywords:
          "personality test, compatibility quiz, myers briggs, personality types",
      },
      "best-date": {
        title: "What is our perfect date?",
        description: "perfect date quiz. Discover your ideal date preferences!",
        keywords:
          "perfect date quiz, dating compatibility, date preferences, relationship quiz",
      },
      "political-alignment": {
        title: "Is our Politics compatible?",
        description:
          "political alignment quiz. See how your political views align!",
        keywords:
          "political quiz, political alignment, political compatibility, politics test",
      },
      "sex-styles": {
        title: "Is our Sex Styles compatible?",
        description: "sex styles quiz. Discover your intimate compatibility!",
        keywords:
          "sex styles quiz, intimate compatibility, relationship compatibility, sexual preferences",
      },
      "attachment-styles": {
        title: "Is our Attachment Style compatible?",
        description: "attachment styles quiz. See how you connect with others!",
        keywords:
          "attachment styles quiz, relationship compatibility, attachment theory",
      },
      "love-languages": {
        title: "What's our Love Language?",
        description:
          "love languages quiz. Discover how you give and receive love!",
        keywords:
          "love languages quiz, relationship compatibility, five love languages",
      },
      "am-i-gay": {
        title: "Am I Gay? Take the Quiz",
        description: "sexuality quiz. Explore your attraction and identity!",
        keywords: "am i gay quiz, sexuality quiz, kinsey scale, lgbtq quiz",
      },
      "affection-profile": {
        title: "What's our Affection Profile?",
        description:
          "affection profile quiz. See how you show and receive love!",
        keywords:
          "affection profile quiz, relationship compatibility, affection styles",
      },
    };

    // Check for remote config metadata first
    if (quizConfig?.displayInfo) {
      return {
        title:
          quizConfig.displayInfo.shareTitle ||
          `Is our ${
            quizConfig.displayInfo.title || quizConfig.titleWord
          } compatible?`,
        description:
          quizConfig.displayInfo.shareDescription ||
          `${
            quizConfig.displayInfo.title || quizConfig.titleWord
          } quiz. See how compatible you are!`,
        keywords:
          quizConfig.displayInfo.keywords ||
          `${quizConfig.titleWord} quiz, compatibility quiz, vibe check`,
      };
    }

    return (
      metadataMap[type] || {
        title: "Vibe Check",
        description: "quiz. See how compatible you are!",
        keywords: "compatibility quiz, vibe check, personality test",
      }
    );
  };

  const metadata = getQuizMetadata(quizType);
  const fullTitle = `${metadata.title} | Vibe Check`;
  const fullDescription = senderName
    ? `${senderName} sent a ${metadata.description}`
    : `${
        metadata.description.charAt(0).toUpperCase() +
        metadata.description.slice(1)
      }`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={metadata.keywords} />

      {/* Open Graph Meta Tags for Facebook, LinkedIn, etc. */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Vibe Check" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />

      {/* Additional Meta Tags */}
      <meta name="author" content="Vibe Check" />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};

export default QuizMetaData;
